module.exports = __webpack_public_path__ + "img/gift-codes-header.205dfb6b.png";